import React from 'react';

import AddIcon from '@material-ui/icons/Add';
import styled from 'styled-components';
import { MeshInSectionHeadingContainer, StyledTypography, StyledButton } from 'styles/common';

import { TextHeader2 } from 'uiToolkitV1/Typography';

function Heading({ heading, color, ...props }) {
  return (
    <TextHeader2 bold color={color} {...props}>
      {heading}
    </TextHeader2>
  );
}

export default function SectionHeading({
  heading,
  headingProps = {},
  headingColor = 'primary',
  actionText,
  actionClick,
  actionComponent,
  HeadingComponent,
}) {
  const mergedProps = { variant: 'h6', display: 'inline', ...headingProps };
  return (
    <MeshInSectionHeadingContainer>
      {HeadingComponent || <Heading color={headingColor} heading={heading} props={mergedProps} />}
      {actionText && (
        <WhiteBackgroundButton onClick={actionClick && actionClick} color="primary" variant="outlined">
          <AddIcon />
          <StyledTypography display="inline" color="primary">
            {actionText}
          </StyledTypography>
        </WhiteBackgroundButton>
      )}
      {actionComponent}
    </MeshInSectionHeadingContainer>
  );
}

const WhiteBackgroundButton = styled(StyledButton)`
  border-radius: 4px;
  background-color: white !important;
`;

SectionHeading.Heading = Heading;
